import React from "react";
import LayoutApp from "../../layout";
import { ArrowLeft, Phone } from "lucide-react";
import { Divider } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useAllContext } from "../../context";
import XButton from "../../components/x-button";
import { handleSignOut } from "../../api";

export default function Profile() {
  const nav = useNavigate();
  const { posts, priorizations, comments, user } = useAllContext();

  function call(number: string) {
    window.open(`tel:${number}`);
  }

  const central = () => {
    const inOpen = posts.filter(
      (_p) =>
        _p?.status?.toLowerCase().replace(" ", "") === "emaberto" &&
        _p?.userId === user?.id
    );
    const inResolved = posts.filter(
      (_p) =>
        _p?.status?.toLowerCase().replace(" ", "") === "resolvido" &&
        _p?.userId === user?.id
    );
    const inPriorizations = priorizations.filter(
      (_p) => _p?.idUser === user?.id
    );
    const inComments = comments.filter((_c) => _c?.userId === user?.id);

    return {
      inOpen,
      inResolved,
      inPriorizations,
      inComments,
    };
  };

  return (
    <LayoutApp>
      <div className="flex flex-col gap-4 pb-10 bg-slate-50">
        <div className="flex flex-row gap-2 items-center justify-start text-lg">
          <ArrowLeft onClick={() => nav(-1)} size={30} />
          <span>Informações</span>
        </div>

        <div className="rounded-sm bg-white shadow p-3 flex flex-col">
          <h1 className="font-bold">Resumo</h1>
          <div className="h-2" />
          <Divider />
          <div className="h-2" />

          <div className="grid grid-cols-2 gap-4 ">
            <div className="flex flex-col w-full h-20 bg-gray-100 rounded-lg  justify-center items-center">
              <span>{central()?.inOpen?.length}</span>
              <span>Em Aberto</span>
            </div>
            <div className="flex flex-col w-full h-20 bg-gray-100 rounded-lg  justify-center items-center">
              <span>{central()?.inResolved?.length}</span>
              <span>Resolvidos</span>
            </div>
            <div className="flex flex-col w-full h-20 bg-gray-100 rounded-lg  justify-center items-center">
              <span>{central()?.inComments.length}</span>
              <span>Comentários</span>
            </div>
            <div className="flex flex-col w-full h-20 bg-gray-100 rounded-lg  justify-center items-center">
              <span>{central()?.inPriorizations.length}</span>
              <span>Priorizações</span>
            </div>
          </div>
        </div>

        <div className="text-base bg-white p-3 shadow ">
          <h1 className="font-bold">Telefones Úteis</h1>
          <div className="h-2" />
          <Divider />
          <div className="h-2" />
          <div className="flex flex-col gap-2 w-full">
            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Ministério da Cidadania</span>
              <div
                onClick={() => call("132")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>
            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Central de Atendimento à Mulher</span>
              <div
                onClick={() => call("180")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Disque Denúncia</span>
              <div
                onClick={() => call("181")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Marinha – Emergências Marítimas / Fluviais</span>
              <div
                onClick={() => call("185")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Linha da Vida - Ministério da Saúde</span>
              <div
                onClick={() => call("188")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Militar</span>
              <div
                onClick={() => call("190")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Rodoviária Federal</span>
              <div
                onClick={() => call("191")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Serviço de Atendimento Médico de Urgência - SAMU</span>
              <div
                onClick={() => call("192")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Corpo de Bombeiros</span>
              <div
                onClick={() => call("193")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Federal</span>
              <div
                onClick={() => call("194")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>SABESP (Somente Estado de São Paulo)</span>
              <div
                onClick={() => call("195")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Ministério da Saúde - Apoio COVID-19</span>
              <div
                onClick={() => call("196")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Civil</span>
              <div
                onClick={() => call("197")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Rodoviária Estadual</span>
              <div
                onClick={() => call("198")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Defesa Civil</span>
              <div
                onClick={() => call("199")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Disque Direitos Humanos</span>
              <div
                onClick={() => call("100")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Caixa Econômica Federal</span>
              <div
                onClick={() => call("111")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Polícia Militar - SOMENTE CELULAR</span>
              <div
                onClick={() => call("112")}
                className="flex flex-row items-center justify-between gap-2"
              >
                {/* <span>/911</span> */}
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Conselhos Tutelares</span>
              <div
                onClick={() => call("125")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Serviços de Emergência no Mercosul</span>
              <div
                onClick={() => call("128")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>

            <div className="flex w-ful items-center justify-between p-2 border-solid border-2 border-gray-200 rounded-full px-4 py-2">
              <span>Ministério da Cidadania</span>
              <div
                onClick={() => call("132")}
                className="flex flex-row items-center justify-between gap-2"
              >
                <div className="bg-green-500 active:bg-green-300 p-2 rounded-full">
                  <Phone color="white" />
                </div>
              </div>
            </div>
          </div>
        </div>

        <XButton
          name="Sair da conta"
          onClick={() => {
            handleSignOut();
            nav("/auth");
          }}
        />
      </div>
    </LayoutApp>
  );
}
